import {
  call,
  put,
  takeEvery,
  takeLeading,
  all,
  take,
  fork,
} from "redux-saga/effects";
import userAPI from "../../../../user/api/UserAPI";
import {
  FETCH_USER_MAILBOX_SELECTIONS_REQUEST,
  DELETE_USER_MAILBOX_SELECTION_REQUEST,
} from "../../../../user/redux/actions/types/UserActionTypes";
import {
  fetchUserMailboxSelectionsFailureActionCreator,
  fetchUserMailboxSelectionsSuccessActionCreator,
  deleteUserMailboxSelectionFailureActionCreator,
  deleteUserMailboxSelectionSuccessActionCreator,
} from "../../../../user/redux/actions/UserActions";
import { postPostalOperatorsMailbox } from "../../api/PostalOperatorsMailboxApi";
import {
  departureMailboxCheckedActionCreator,
  retrieveOutboundPostalOperatorsMailboxFailureActionCreator,
  retrieveOutboundPostalOperatorsMailboxSuccessActionCreator,
} from "../actions/DeparturePostalOperatorActions";
import {
  arrivalMailboxCheckedActionCreator,
  retrieveInboundPostalOperatorsMailboxFailureActionCreator,
  retrieveInboundPostalOperatorsMailboxSuccessActionCreator,
} from "../actions/ArrivalPostalOperatorActions";
import { RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST } from "../actions/types/DeparturePostalOperatorActionTypes";
import { RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST } from "../actions/types/ArrivalPostalOperatorActionTypes";
import OperatorTypes from "../../../../common/redux/actions/types/OperatorTypes";
import DirectionTypes from "../../../../common/redux/actions/types/DirectionTypes";

function* retrieveOutboundPostalOperatorWorker(action) {
  let operatorType =
    action.payload.defaultDirection === DirectionTypes.INBOUND
      ? OperatorTypes.DEPARTURE
      : OperatorTypes.ARRIVAL;
  const stretch =
    action.payload.defaultDirection === DirectionTypes.OUTBOUND
      ? "INBOUND"
      : "OUTBOUND";
  try {
    const postalOperatorsResponse = yield call(postPostalOperatorsMailbox, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(
      retrieveOutboundPostalOperatorsMailboxSuccessActionCreator(
        postalOperatorsResponse.data
      )
    );

    if (
      action.departureCheckedMailboxes &&
      action.departureCheckedMailboxes.length
    )
      return;

    let lastUserMailboxSelectionResponse = yield call(
      userAPI.getLastUserMailboxSelection,
      operatorType,
      action.payload.defaultDirection
    );
    let lastUserMailboxSelection = lastUserMailboxSelectionResponse.data;
    if (
      (stretch === "OUTBOUND" &&
        lastUserMailboxSelection.direction !==
          action.payload.defaultDirection) ||
      (stretch === "INBOUND" &&
        lastUserMailboxSelection.direction === action.payload.defaultDirection)
    ) {
      operatorType =
        operatorType === OperatorTypes.DEPARTURE
          ? OperatorTypes.ARRIVAL
          : OperatorTypes.DEPARTURE;
      lastUserMailboxSelectionResponse = yield call(
        userAPI.getLastUserMailboxSelection,
        operatorType,
        action.payload.defaultDirection
      );
      lastUserMailboxSelection = lastUserMailboxSelectionResponse.data;
    }

    if (lastUserMailboxSelection && action.reportDefinition !== "Admin") {
      if (stretch === "OUTBOUND") {
        if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
          yield put(
            departureMailboxCheckedActionCreator(
              lastUserMailboxSelection.ediMailboxes,
              action.reportDefinition
            )
          );
        } else {
          yield put(
            arrivalMailboxCheckedActionCreator(
              lastUserMailboxSelection.ediMailboxes,
              action.reportDefinition
            )
          );
        }
      } else if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
        yield put(
          arrivalMailboxCheckedActionCreator(
            lastUserMailboxSelection.ediMailboxes,
            action.reportDefinition
          )
        );
      } else {
        yield put(
          departureMailboxCheckedActionCreator(
            lastUserMailboxSelection.ediMailboxes,
            action.reportDefinition
          )
        );
      }
    }
  } catch (error) {
    yield put(
      retrieveOutboundPostalOperatorsMailboxFailureActionCreator(error)
    );
  }
}

function* retrieveInboundPostalOperatorWorker(action) {
  let operatorType =
    action.payload.defaultDirection === DirectionTypes.INBOUND
      ? OperatorTypes.ARRIVAL
      : OperatorTypes.DEPARTURE;
  const stretch =
    action.payload.defaultDirection === DirectionTypes.INBOUND
      ? "INBOUND"
      : "OUTBOUND";
  try {
    const postalOperatorsResponse = yield call(postPostalOperatorsMailbox, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(
      retrieveInboundPostalOperatorsMailboxSuccessActionCreator(
        postalOperatorsResponse.data
      )
    );

    if (action.arrivalCheckedMailboxes && action.arrivalCheckedMailboxes.length)
      return;

    let lastUserMailboxSelectionResponse = yield call(
      userAPI.getLastUserMailboxSelection,
      operatorType,
      action.payload.defaultDirection
    );
    let lastUserMailboxSelection = lastUserMailboxSelectionResponse.data;
    if (
      (stretch === "INBOUND" &&
        lastUserMailboxSelection.direction !==
          action.payload.defaultDirection) ||
      (stretch === "OUTBOUND" &&
        lastUserMailboxSelection.direction === action.payload.defaultDirection)
    ) {
      operatorType =
        operatorType === OperatorTypes.DEPARTURE
          ? OperatorTypes.ARRIVAL
          : OperatorTypes.DEPARTURE;
      lastUserMailboxSelectionResponse = yield call(
        userAPI.getLastUserMailboxSelection,
        operatorType,
        action.payload.defaultDirection
      );
      lastUserMailboxSelection = lastUserMailboxSelectionResponse.data;
    }

    if (lastUserMailboxSelection && action.reportDefinition !== "Admin") {
      if (stretch === "INBOUND") {
        if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
          yield put(
            arrivalMailboxCheckedActionCreator(
              lastUserMailboxSelection.ediMailboxes,
              action.reportDefinition
            )
          );
        } else {
          yield put(
            departureMailboxCheckedActionCreator(
              lastUserMailboxSelection.ediMailboxes,
              action.reportDefinition
            )
          );
        }
      } else if (action.payload.defaultDirection === DirectionTypes.INBOUND) {
        yield put(
          departureMailboxCheckedActionCreator(
            lastUserMailboxSelection.ediMailboxes,
            action.reportDefinition
          )
        );
      } else {
        yield put(
          arrivalMailboxCheckedActionCreator(
            lastUserMailboxSelection.ediMailboxes,
            action.reportDefinition
          )
        );
      }
    }
  } catch (error) {
    yield put(retrieveInboundPostalOperatorsMailboxFailureActionCreator(error));
  }
}

function* fetchUserMailboxSelectionsWorker(action) {
  try {
    const postalOperatorType = action.payload;

    const userMailboxSelectionsResponse = yield call(
      userAPI.getUserMailboxSelections,
      postalOperatorType
    );
    const selections = userMailboxSelectionsResponse.data;

    yield put(
      fetchUserMailboxSelectionsSuccessActionCreator(
        postalOperatorType,
        selections
      )
    );
  } catch (error) {
    yield put(fetchUserMailboxSelectionsFailureActionCreator(error));
  }
}

function* deleteUserMailboxSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserMailboxSelection, action.payload);
    yield put(deleteUserMailboxSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserMailboxSelectionFailureActionCreator(error));
  }
}

function* watchFetchUserMailboxSelections() {
  const inProgress = {};

  while (true) {
    const action = yield take(FETCH_USER_MAILBOX_SELECTIONS_REQUEST);
    const operatorType = action.payload;

    if (!inProgress[operatorType]) {
      inProgress[operatorType] = true;

      yield fork(function* executeMailboxFetch() {
        try {
          yield call(fetchUserMailboxSelectionsWorker, action);
        } finally {
          inProgress[operatorType] = false;
        }
      });
    }
  }
}

function* postalOperatorsWatcher() {
  yield all([
    takeLeading(
      RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
      retrieveOutboundPostalOperatorWorker
    ),
    takeLeading(
      RETRIEVE_INBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST,
      retrieveInboundPostalOperatorWorker
    ),
    fork(watchFetchUserMailboxSelections),
    takeEvery(
      DELETE_USER_MAILBOX_SELECTION_REQUEST,
      deleteUserMailboxSelectionsWorker
    ),
  ]);
}

export default postalOperatorsWatcher;
